import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatAccordion } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config.service';
import { AdminService } from '../common/adminService';
import { environment } from 'environments/environment';
import { fuseAnimations } from '@fuse/animations';
@Component({
  selector: 'app-educationalwebview',
  templateUrl: './educationalwebview.component.html',
  styleUrls: ['./educationalwebview.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class EducationalwebviewComponent implements OnInit {

  id: string;
  getContentData: any;
  view:any; 
  @ViewChild(MatAccordion) accordion: MatAccordion;

  /** For ExpandAll & CollapseAll */
  panelOpenState: boolean = false;
  allExpandState = false;
  contentType: any;
  index: any;
  sDescription
  sContentDescription
  openIndex: any;
  closeIndex: any;
  eUploadType;
  isIOSDevice: boolean = false;
  sBannerimage:any;
  constructor(
    private _fuseConfigService: FuseConfigService,
    private route: ActivatedRoute,
    private adminService: AdminService,
    private router: Router
  ) {
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    };

    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });
  }

  ngOnInit() {
    var classNames = [];
    if (navigator.userAgent.match(/(iPad|iPhone|iPod)/i)) {
      this.isIOSDevice = true;
    }

    if (navigator.userAgent.match(/android/i)) {
      this.isIOSDevice = false;
    }

    this.adminService.viewEducational(this.id).subscribe((content) => {
      this.view = content['data']
      
      this.eUploadType = this.view.eUploadType
      this.sDescription = this.view.sDescription
      if(this.view.sContentDescription === "null") 
      {this.sContentDescription = ''}
      else this.sContentDescription = this.view.sContentDescription
      this.sBannerimage = environment.sBannerImages + this.view.sBannerImage;
      if(this.eUploadType === 'Audio') this.sDescription = environment.sAudioFile +this.view.sDescription
        if(this.eUploadType === 'Video') this.sDescription = environment.sVideoFile +this.view.sDescription
      // if (this.contentType !== 'aCollapse_table') {
      //   this.router.navigate(['errors/error-404']);
      // }
    }, error => {
      
      
      this.router.navigate(['errors/error-404']);
    });
  }

  openState(i) {
    this.openIndex = i;
    this.panelOpenState = true
  }

  closeState(i) {
    this.closeIndex = i;
    this.panelOpenState = false
  }

}
